import { useAuth } from "@/contexts/auth";
import { useTranslation } from "react-i18next";
import { Outlet, useParams } from "react-router";
import NoCustomerSelected from "@/components/elements/no-customer-selected";

function RequireCustomerId() {
  const { customerId, isAuthorized, isLoading } = useAuth();
  const { t } = useTranslation();
  const { customerId: urlCustomerId } = useParams();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center gap-2">
        {t("common.status.global.loading")}
      </div>
    );
  }

  if (!customerId || !isAuthorized || (urlCustomerId && Number(urlCustomerId) !== customerId)) {
    return <NoCustomerSelected />;
  }

  return <Outlet />;
}

export default RequireCustomerId;
